import { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useScrollToTop } from 'hooks/useScrollToTop';
import { selectRewardsActiveMonth } from 'modules/SalaryModule/RewardsTable/selectors';
import {
  setRewardActiveMonth,
  upsertEmployeeReward,
} from 'modules/SalaryModule/RewardsTable/actions';
import { setRewardsFamily } from 'modules/SalaryModule/Rewards/actions';
import { RewardsToolbar } from '../../../components/SalaryComponents/RewardsToolbar';
import { selectUserCurrentCompany } from '../../../modules/loggedUserInfo/selectors';
import { RewardsTable } from './RewardsTable';
import Styles from './RewardsPage.module.css';
import moment from 'moment';

export const RewardsPage = memo(() => {
  const dispatch = useDispatch();

  const { id: companyId, managedSilae } = useSelector(selectUserCurrentCompany);
  const rewardsActiveMonth = useSelector(selectRewardsActiveMonth);

  const [currentPage, setCurrentPage] = useState(1);
  const [activeFamily, setActiveFamily] = useState('');
  const [selectedBranch, setSelectedBranch] = useState('');
  const [employeeIdXlsx, setEmployeeIdXlsx] = useState(null);

  const setActiveMonth = useCallback(
    (activeMonth) => {
      dispatch(setRewardActiveMonth(activeMonth));
    },
    [dispatch]
  );

  useScrollToTop();

  useEffect(
    () => () => {
      dispatch(setRewardsFamily(null));
    },
    [dispatch]
  );

  const onUpsertEmployeeReward = useCallback(
    ({ value, companyRewardId, employeeId }) => {
      dispatch(
        upsertEmployeeReward({
          companyId,
          data: {
            value,
            companyRewardId,
            employeeId,
            date: {
              year: moment(rewardsActiveMonth).year(),
              month: moment(rewardsActiveMonth).month() + 1,
            },
          },
        })
      );
    },
    [dispatch, rewardsActiveMonth]
  );

  return (
    <div className={Styles.container}>
      <RewardsToolbar
        companyId={companyId}
        activeMonth={moment(rewardsActiveMonth)}
        setActiveMonth={setActiveMonth}
        employeeIdXlsx={employeeIdXlsx}
        setEmployeeIdXlsx={setEmployeeIdXlsx}
        activeFamily={activeFamily}
        selectedBranch={selectedBranch}
        setActiveFamily={setActiveFamily}
        setSelectedBranch={setSelectedBranch}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        managedSilae={managedSilae}
      />
      <RewardsTable
        setEmployeeIdXlsx={setEmployeeIdXlsx}
        setEmployeeRewardData={onUpsertEmployeeReward}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        selectedBranch={selectedBranch}
        activeMonth={moment(rewardsActiveMonth)}
      />
    </div>
  );
});
